import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-product-stock-management',
  templateUrl: './product-stock-management.component.html',
  styleUrls: ['./product-stock-management.component.css']
})
export class ProductStockManagementComponent implements OnInit {
  
  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  stocks:any = []

  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  productSearch: any = ""
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.getProductStock(this.pageNumber,this.recordsPerPage)
  }


  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    console.log(event)

    if(this.productSearch != ""){
      this.searchByNamePageChange(this.pageNumber,this.recordsPerPage)

    }else{
      this.getProductStock(this.pageNumber,this.recordsPerPage)
    }
  }


  getProductStock(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    this.generic_service.getProductStock(pageNumber,recordsPerPage).subscribe(
      (res:any)=>{
        console.log(res)
        this.totalRecords = res.response.totalRecords
        this.stocks = res.response.productStockInfoList
        this.isLoading = false

      },(error:any)=>{
        console.log(error)
      }
    )
  }

  searchByNamePageChange(pageNumber:any,recordsPerPage:any){
    this.generic_service.getProductStockByName(this.productSearch,pageNumber,recordsPerPage).subscribe(
      (res:any)=>{
        console.log(res)
        this.totalRecords = res.response.totalRecords
        this.stocks = res.response.productStockInfoList
      },(error:any)=>{
        console.log(error)
      }
    )
  }

  getProductStockByName(){
    this.pageNumber = 0;

    if(this.productSearch == ""){
      this.getProductStock(this.pageNumber,this.recordsPerPage)
      return
    }
    this.generic_service.getProductStockByName(this.productSearch,this.pageNumber,this.recordsPerPage).subscribe(
      (res:any)=>{
        console.log(res)
        this.totalRecords = res.response.totalRecords
        this.stocks = res.response.productStockInfoList
      },(error:any)=>{
        console.log(error)
      }
    )
  }


  refreshAll(){
    this.pageNumber = 0
    this.productSearch = ""
    this.getProductStock(this.pageNumber,this.recordsPerPage)
  }

}